import { DATA_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'dynamicValidUploads',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Valid Dynamic Uploads',
  },
}

const keys = {
  statKey: 'posted_valid_prospects',
  componentKeys: [DATA_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
}

const dynamicValidUploads = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { dynamicValidUploads }
